import {FC} from 'react'

import {useCommonContent} from '@/content/common'
import {useTranslation} from '@/i18n'
import {theme} from '@/theme/theme'
import {TABLET_SCREENSIZE} from '@/utils/styles/breakpoints'

import {ArrowIcon} from '../icons/ArrowIcon'
import {BUTTON_BORDER_RADIUS} from './Button'
import {Text, TextFontWeight, TextVariant} from './Text'

export const MAIN_CONTENT_ID = 'main-content'

export const SkipToContentLink: FC = () => {
  const {t} = useTranslation()
  const {skipToContentLink} = useCommonContent()

  return (
    <>
      <a href={`#${MAIN_CONTENT_ID}`} className="skip-link">
        <Text variant={TextVariant.subtitle13} fontWeight={TextFontWeight.bold}>
          {t(skipToContentLink)}
        </Text>
        <span className="arrow" aria-hidden="true">
          <ArrowIcon variant="down" color={theme.palette.button.tertiary.contrastText} />
        </span>
      </a>

      <style jsx>{`
        .skip-link {
          position: fixed;
          top: ${theme.spacing[4.5]};
          left: ${theme.spacing[4.5]};
          z-index: 1001;
          display: flex;
          gap: ${theme.spacing[1.5]};
          padding: 10px ${theme.spacing[2.5]};
          border-radius: ${BUTTON_BORDER_RADIUS}px;
          border: 1px solid ${theme.palette.button.tertiary.outlineColor};
          background-color: ${theme.palette.button.tertiary.main};
          color: ${theme.palette.button.tertiary.contrastText};
          text-decoration: none;
        }
        .arrow {
          display: flex;
        }
        .skip-link:not(:focus) {
          width: 1px;
          height: 1px;
          padding: 0;
          border: 0;
          overflow: hidden;
          clip-path: inset(50%);
          white-space: nowrap;
        }
        @media ${TABLET_SCREENSIZE} {
          .skip-link {
            top: ${theme.spacing[2.5]};
            left: ${theme.spacing[2.5]};
          }
        }
      `}</style>
    </>
  )
}
